import React, { useState, useEffect } from 'react';

import CardDastgahEjraee from './CardDastgahEjraee.tsx';
import T2tree from '../treeview/ChapterThematicListTree.js';
import BG from '../../../images/image/footer-background7.png';
import SearchableDropDownChapterCodeMozoee from '../../../SearchableDropDown/SearchableDropDownChapterCodeMozoee.tsx';

const Test = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'ابواب و فصول کدهای موضوعی';

    return () => {};
  }, []);

  return (
    <div className=" container px-4 font-IranSans">
      <div
        dir="rtl"
        //  className="grid grid-cols-1 mySize:grid-cols-5 gap-4"
        className="grid grid-cols-12 gap-4 "
      >
        <div className="bg-white block border relative rounded-md duration-300 border-gray-300 col-span-12 lg:col-span-3  p-4 shadow-sm h-[750px]  ">
          {/* <h1>انتخاب موضوع سرشاخه</h1> */}

          <div
            className=" relative text-center my-5  flex items-center justify-center font-bold w-full p-1 
                     align-icon "
          >
            {/* <img
              src={BG}
              alt=""
              className="absolute  rounded-xl h-14 object-cover w-full"
            /> */}
            {/* <div className="w-24 h-24 bg-white rounded-full absolute "></div> */}
            <div className="w-full bg-[#a179c7] py-4  rounded-lg absolute"></div>
            <p className="absolute text-white  text-wrap w-full text-center text-[14px] ">
              کدهای موضوعی{' '}
            </p>
          </div>
          <hr />
          <div className="w-full flex items-center justify-between mb-1">
            <label className="h-full w-[20%] text-[14px] flex items-start justify-start font-IranSans">
              انتخاب موضوع سرشاخه{' '}
            </label>
            <SearchableDropDownChapterCodeMozoee />
          </div>
          <div className="h-5/6 overflow-auto mt-1">
            <T2tree />
          </div>
        </div>

        <div
          className="bg-white shadow-md rounded-md px-4 pt-6 pb-2 border border-gray-300 col-span-12 lg:col-span-9 "
          // className="bg-white shadow-md rounded-md px-4 pt-6 pb-20 border border-gray-300 col-span-5 mySize:col-span-7 "
        >
          <CardDastgahEjraee />
        </div>
      </div>
    </div>
  );
};

export default Test;
